import React from 'react'

import { DropdownItemProps } from './DropdownButton'
import { MatchProductsButton, MatchProductsButtonBaseProps } from './MatchProductsButton'

import { useLogic } from '../hooks/storeHook'

import { OzonProductProp } from '../server/mpsklad_core/Models/OzonProductProp'
import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'

export type MatchButtonProps =
  DropdownItemProps
  & MatchProductsButtonBaseProps

export const ozonMatchingProps = [
  [OzonProductProp.Article, 'Артикул'],
  [OzonProductProp.Name, 'Название'],
  [OzonProductProp.Barcode, 'Штрихкод']
] as const

export const MatchOzonToMoySkladButton =
  (props: MatchButtonProps) => {
    const logic = useLogic()

    return (
      <MatchProductsButton
        {...props}
        fromIntegrationType={IntegrationType.Ozon}
        fromProps={ozonMatchingProps}
        submit={logic.matchOzonToMoySkladProducts}
      />
    )
  }